module.exports = __webpack_public_path__ + "static/media/carnet-front.1d52927e.png";